let lastDispatchedGuildId;

export const dispatchGuildSelection = (guild) => {
  const nextGuild = guild || null;
  const nextGuildId = String(nextGuild?.id || '');
  if (lastDispatchedGuildId === nextGuildId) return false;

  lastDispatchedGuildId = nextGuildId;
  window.dispatchEvent(
    new CustomEvent('tns:guild-selected', {
      detail: { guild: nextGuild },
    }),
  );
  return true;
};

export const resetGuildSelectionDispatchForTests = () => {
  lastDispatchedGuildId = undefined;
};
